import news from '../api/news.api'
import store from './index.js'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  articles: [],
  detailedArticle: null,
  isLiked: null,
  articleCount: 0
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshNewsList (state, news) {
    state.articles = news
  },
  refreshNewsCount (state, newCount) {
    state.articleCount = newCount
  },
  isLiked (state, liked) {
    state.isLiked = liked
  },
  addDetailedArticle (state, article) {
    state.detailedArticle = article
  }
}
var running = false
// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  refreshNewsList (context) {
    news.api.getAllNews()
      .then(response => {
        context.commit('refreshNewsList', response.data)
      },
      error => {
        console.log('impossible to load news list from api: ' + error.text())
      })
  },
  getNewsPage (context, pageId) {
    if (running === true) {
      return
    }
    running = true
    news.api.getPaginatedNews(pageId)
      .then(response => {
        context.commit('refreshNewsCount', response.data.count)
        context.commit('refreshNewsList', response.data.results)
        running = false
      },
      error => {
        console.log('impossible to load news list from api: ' + error.text())
        running = false
      })
  },
  getDetailedArticle (context, id) {
    // si l'article cherché n'est pas en cache
    news.api.getDetailedNews(id)
      .then(response => {
        context.commit('addDetailedArticle', response.data)
      },
      error => {
        console.log('impossible to detailed news : ' + error.text())
      })
  },
  getIsLiked (context, likedatas) {
    news.api.isLiked(likedatas[0], likedatas[1])
      .then(response => {
        if (response.data.length > 0) {
          context.commit('isLiked', true)
        } else {
          context.commit('isLiked', false)
        }
      },
      error => {
        console.log('impossible to know if news is liked : ' + error.text())
      })
  },
  likeNews (context, likedatas) {
    // si l'article cherché n'est pas en cache
    news.api.likeNews(likedatas[0], likedatas[1])
      .then(response => {
        if (response.status === 201) {
          context.commit('isLiked', true)
          context.dispatch('getDetailedArticle', likedatas[1])
        }
      },
      error => {
        console.log('impossible to like news : ' + error.text())
      })
  },
  dislikeNews (context, likedatas) {
    // si l'article cherché n'est pas en cache
    news.api.disLikeNews(likedatas[0], likedatas[1])
      .then(response => {
        context.commit('isLiked', false)
        context.dispatch('getDetailedArticle', likedatas[1])
      },
      error => {
        console.log('impossible to dislike news : ' + error.text())
      })
  },
  invalidateListArticle (context) {
    context.commit('articles', null)
  },
  invalidateDetailedArticle (context) {
    context.commit('addDetailedArticle', null)
  }
}

// getters are functions
const getters = {
  allNews: state => {
    return state.articles
  },
  allFilteredNews: state => {
    if (store.getters.activatedClub && state.articles) {
      let al = store.getters.activatedClub
      let filtered = state.articles.filter(article => { return article.featured_club !== undefined && article.featured_club.id === al.id })
      return filtered
    }
    return state.articles
  },
  // get the latest news
  latestNews: state => {
    return state.articles[0]
  },
  filteredLatestNews: state => {
    if (store.getters.activatedClub && state.articles) {
      let al = store.getters.activatedClub
      let filtered = state.articles.filter(article => { return article.featured_club !== undefined && article.featured_club.id === al.id })
      return filtered[0]
    }
    return state.articles[0]
  },
  // all news but the latest
  newsList: state => {
    return state.articles.slice(1, state.articles.length)
  },
  filteredNewsList: state => {
    if (store.getters.activatedClub && state.articles) {
      let al = store.getters.activatedClub
      let filtered = state.articles.filter(article => { return article.featured_club !== undefined && article.featured_club.id === al.id })
      return filtered.slice(1, state.articles.length)
    }
    return state.articles.slice(1, state.articles.length)
  },
  isLiked: state => {
    return state.isLiked
  },
  detailedNews: state => {
    return state.detailedArticle
  },
  newsCount: state => {
    return state.articleCount
  },
  pageCount: state => {
    return Math.ceil(state.articleCount / 10)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/news.js